import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Exists } from './exists.interface';

export class ExistsService {
   async getExists(
      candidateId?: number | null,
      first_name?: string,
      last_name?: string,
      phone_number?: string,
      email?: string,
      social_security_number?: { social_security_number: string; social_security_number_mask_type_id: number },
   ) {
      const response = await http.post<ApiResource<Exists>>(`/candidates/exists/${candidateId || ''}`, {
         first_name,
         last_name,
         phone_number,
         email,
         social_security_number,
      });

      return response.data;
   }
}
